import {
   chatInit,
   fetchMessages,
   messageLikedMembers,
   openClosedPrivateConversation,
} from 'sites/api/AuthApi';

import * as actions from "./actions";


export const chatInitOperation = (fetch = true) => {
   return async (dispatch, getState) => {
      if(fetch) {
         dispatch(actions.chatInitRequest())
      }
      try {
         const { data } =  await chatInit();
         let state = {
            privateChat: {
               ...data.data.private_chat,
               typers: {},
            },
            groupChat: {
               ...data.data.group_chat,
               typers: {},
            },
            settings: data.chat_settings,
         }
         if(!fetch){
            const { chat: { privateChat, groupChat } } = getState()
            state.privateChat = privateChat;
            state.groupChat = groupChat;
         }

         if(!state.settings.is_group_chat_active && !state.settings.chat_private_is_active){
            dispatch(actions.setChatIconState(true))
         }
         dispatch(actions.chatInitCompleted(state))
      } catch (error) {
         if(error.response) {
            dispatch(actions.chatInitFailed(error.response))
         }
      }
   };
};
export const fetchMessagesOperation = (id, info, inted, callback) => {
   return async (dispatch) => {
      let type = info.type
      if(!type) {
         type = !info.user_uuid ? 'public' : 'private'
      }
      if(inted) {
         await dispatch(actions.setActiveTab({
            type: type,
            id,
            userUUid: info.user_uuid,
            conversation: {
               conversation_name: info.conversation_name || info.username,
               avatars: info.avatars || info.user_avatar,
            },
         }))
      } else {
         dispatch(actions.fetchMessagesRequest({ type }))
      }
      try {
         if(!inted) {
            let converstionId = id
            let data = {
               data: {
                  data: [],
               },
            }
            if(!!id) {
               let res =  await fetchMessages(converstionId);
               data = res.data
            }
            let type = null
            if(!info.user_uuid){
               type = 'public'
            } else {
               type = 'private'
            }
            dispatch(actions.fetchMessagesCompleted({
               data: data.data,
               id: id,
               userUUid: info.user_uuid,
               type,
               conversation: {
                  conversation_name: info.conversation_name || info.username,
                  avatars: info.avatars || info.user_avatar,
               },
            }
            ))
         }
         if(callback) {
            callback()
         }
      } catch (error) {
         if(error.response) {
            dispatch(actions.fetchMessagesFailed(error.response))
         }
      }
   };
};
export const fetchNextMessagesOperation = (id, page) => {
   return async (dispatch) => {
      dispatch(actions.fetchNextMessagesRequest())
      try {
         const { data } =  await fetchMessages(id, page);
         dispatch(actions.fetchNextMessagesCompleted(data.data))
      } catch (error) {
         if(error.response) {
            dispatch(actions.fetchNextMessagesFailed(error.response))
         }
      }
   };
};
export const fetchMessageLikedMembersOperation = (id, page) => {
   return async (dispatch) => {
      dispatch(actions.fetchMessageLikedMembersRequest(!page))
      try {
         const { data } =  await messageLikedMembers(id, page);
         dispatch(actions.fetchMessageLikedMembersCompleted({
            isPagination: page,
            data,
         }))
      } catch (error) {
         if(error.response) {
            dispatch(actions.fetchMessageLikedMembersFailed(error.response))
         }
      }
   };
};
export const openClosedConversationOperation = (conversationId) => {
   return async (dispatch) => {
      try {
         await openClosedPrivateConversation(conversationId)
         dispatch(actions.openClosedConversationCompleted())
      } catch (error) {
         console.log(error);
      }
   }
}
